import { NotificationsComponent } from './pages/notifications/notifications.component';
import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { LoginComponent } from './auth/login/login.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { AuthGuard } from './auth/auth.guard';
import { MainLayoutComponent } from './layouts/main-layout/main-layout';
import { UnauthorizedLayoutComponent } from './layouts/unauthorized-layout/unauthorized-layout';
import { OrdersComponent } from './pages/orders/orders.component';
import { FilesComponent } from './pages/files/files.component';
import { CreateFilesComponent } from './pages/files/create-files/create-files.component';
import { CreateOrderComponent } from './pages/orders/create-order/create-order.component';
import { pendingChangesGuard } from '../core/guards/pending-changes.guard';
import { SettingsComponent } from "./pages/settings/settings.component";
export const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'notifications', component: NotificationsComponent },
      { path: 'dashboard', component: DashboardComponent },
      { path: 'orders', component: OrdersComponent },
      { path: 'orders/create', component: CreateOrderComponent, canDeactivate: [pendingChangesGuard] },
      { path: 'orders/:id/edit', component: CreateOrderComponent, canDeactivate: [pendingChangesGuard] },
      { path: 'orders/:id', component: OrdersComponent },
      { path: 'files', component: FilesComponent },
      { path: 'files/create', component: CreateFilesComponent },
      { path: 'settings', component: SettingsComponent },
      { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
    ]
  },
  {
    path: '',
    component: UnauthorizedLayoutComponent,
    children: [
      { path: 'login', component: LoginComponent },
    ]
  },
  { path: '**', redirectTo: '/dashboard' }
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
